import React from "react";
import { AppBar, Box, Link, Toolbar } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import logoUrl from "../../../assets/images/02_washpass.png";

const RegisterHeader = () => {
  return (
    <>
      <AppBar sx={{ alignItems: "center", backgroundColor: "#46558C" }}>
        <Toolbar>
          <Link component={RouterLink} to="/" sx={{ mr: 2 }}>
            <Box
              sx={{
                width: "auto",
                height: "40px",
              }}
            >
              <img
                src={logoUrl}
                alt="Logo"
                style={{ height: "100%" }}
              />
            </Box>
          </Link>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default RegisterHeader;
